import { getCachedSpace, useSpaceUtil } from '@tribeplatform/react-sdk/hooks';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionsKey, getSpaceKey, getSpacesKey } from '../../utils/keys';
export const useUpdateSpace = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const spaceUtils = useSpaceUtil();
    const collectionsKey = getCollectionsKey();
    return useMutation((input) => client.spaces.update(input, fields), {
        onMutate: async (data) => {
            const spaceKey = getSpaceKey({ variables: { id: data.id } });
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries(spaceKey);
            // Snapshot the previous value
            const snapshot = getCachedSpace({ id: data.id }, queryClient, spaceUtils);
            // Optimistically update to the new value
            const spaceInput = data.input;
            const spaceUpdater = (old) => ({
                ...old,
                ...{
                    ...spaceInput,
                    slate: old === null || old === void 0 ? void 0 : old.slate,
                    address: { ...old === null || old === void 0 ? void 0 : old.address, ...spaceInput === null || spaceInput === void 0 ? void 0 : spaceInput.address },
                    seoDetail: { ...old === null || old === void 0 ? void 0 : old.seoDetail, ...spaceInput === null || spaceInput === void 0 ? void 0 : spaceInput.seoDetail },
                },
            });
            queryClient.setQueriesData(spaceKey, spaceUpdater);
            // Return a context object with the snapshotted value
            return { snapshot };
        },
        onSuccess: data => {
            const spaceKey = getSpaceKey({ variables: { id: data.id } });
            queryClient.setQueriesData(spaceKey, oldData => ({
                ...oldData,
                ...data,
            }));
        },
        onError: (err, newSpace, context) => {
            const spaceKey = getSpaceKey({ variables: { id: newSpace.id } });
            // revert back the optimistic response
            queryClient.setQueriesData(spaceKey, context.snapshot);
        },
        onSettled: (data, error, variables) => {
            const spacesKey = getSpacesKey();
            queryClient.invalidateQueries(spacesKey);
            const spaceKey = getSpaceKey({ variables: { id: variables === null || variables === void 0 ? void 0 : variables.id } });
            queryClient.invalidateQueries(spaceKey);
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateSpace.js.map